import React, { useState, useCallback } from 'react'
import { useHistory } from 'react-router'
import SelectCampaign from './Select'
import Upload from './Upload'
import Send from './Send'
import { AppContext, useAppContext } from '../../libs/context'
import Steps from '../../components/Steps'
import { UsersIcon } from '@heroicons/react/24/outline'
import i18n from '../../i18n'

const Campaign = () => {
  const search = window.location.search
  const qParams = new URLSearchParams(search)
  const currentTab = qParams.get('step') || 'select'
  const history = useHistory()
  const { updateNav } = useAppContext()
  const [stepsData, setStepsData] = useState([
    {
      id: 1,
      name: i18n.t('select_template'),
      href: 'select',
      current: true,
      completed: false
    },
    {
      id: 2,
      name: i18n.t('upload_contacts'),
      href: 'upload',
      current: false,
      completed: false
    },
    {
      id: 3,
      name: i18n.t('send'),
      href: 'send',
      current: false,
      completed: false
    }
  ])
  const [campaignsTypes, setCampaignsTypes] = useState([])
  const [selectedCampaign, setSelectedCampaign] = useState(null)
  const [contacts, setContacts] = useState([])
  // Campaña basada en Excel CaixaBank: cuando Upload detecta un .xlsx/.xlsm, en
  // vez de lanzar en el acto guarda aquí el fichero (base64), el flow y el
  // resumen dryRun (a quién se cierra). Send lo usa para lanzar/programar vía
  // /process-excel manteniendo la lógica de cierre de flujos. null = flujo normal.
  const [excelJob, setExcelJob] = useState(null)
  const [stat, setStat] = useState({
    name: i18n.t('total_subscribers'),
    users: '0',
    icon: UsersIcon
  })

  // Función para verificar si se puede navegar a un paso
  const canNavigateToStep = useCallback((targetStepId) => {
    // Siempre se puede ir al paso 1
    if (targetStepId === 1) return true
    
    // Para ir al paso 2, debe haber seleccionado un template
    if (targetStepId === 2) {
      return selectedCampaign !== null
    }
    
    // Para ir al paso 3, debe haber seleccionado template Y subido contactos
    if (targetStepId === 3) {
      return selectedCampaign !== null && contacts.length > 0
    }
    
    return false
  }, [selectedCampaign, contacts])

  // Función para obtener el mensaje de error según el paso
  const getStepValidationMessage = useCallback((targetStepId) => {
    if (targetStepId === 2 && !selectedCampaign) {
      return i18n.t('select_template_first') || 'Please select a template first'
    }
    if (targetStepId === 3) {
      if (!selectedCampaign) {
        return i18n.t('select_template_first') || 'Please select a template first'
      }
      if (contacts.length === 0) {
        return i18n.t('upload_contacts_first') || 'Please upload contacts first'
      }
    }
    return null
  }, [selectedCampaign, contacts])

  const onStepClick = (step, forceNavigation = false) => {
    // Validar si se puede navegar al paso
    if (!forceNavigation && !canNavigateToStep(step.id)) {
      const message = getStepValidationMessage(step.id)
      if (message) {
        alert(message)
      }
      return
    }

    history.push({
      search: `?step=${step.href}`
    })
    let stepsDataMod = [...stepsData]
    const currentStep = stepsDataMod.find(({ current }) => current)
    if (currentStep) {
      currentStep.current = false
    }
    const targetStep = stepsDataMod.find(({ id }) => id === step.id)
    if (targetStep) {
      targetStep.current = true
    }
    setStepsData(stepsDataMod)
  }

  return (
    <AppContext.Provider
      value={{
        campaignsTypes,
        setCampaignsTypes,
        selectedCampaign,
        setSelectedCampaign,
        onStepClick,
        canNavigateToStep,
        getStepValidationMessage,
        contacts,
        setContacts,
        excelJob,
        setExcelJob,
        stepsData,
        setStepsData,
        stat,
        setStat,
        updateNav
      }}
    >
      <Steps />
      {currentTab === 'select' && <SelectCampaign />}
      {currentTab === 'upload' && <Upload />}
      {currentTab === 'send' && <Send />}
    </AppContext.Provider>
  )
}

export default Campaign
